import React from 'react';
import { Heading } from '@grubhubprod/gh-cookbook-react';
import { Square, Stack } from '@grubhubprod/gh-cookbook-react/dist';
import { useParams } from 'react-router-dom';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import { Breadcrumbs } from 'src/components/Breadcrumbs/Breadcrumbs';
import { EnterpriseManageInvoiceRecipients } from 'src/components/enterprise/EnterpriseInvoiceRecipients/EnterpriseManageInvoiceRecipients';
import { SubtotalInvoiceMethod } from 'src/utilities/invoiceContact.utils';
import PageSection from 'src/components/enterprise/layout/PageSection';
import { getHomeBreadcrumb } from 'src/constants/urls';

export default function EnterpriseInvoiceRecipients(): JSX.Element {
  const { corpid } = useParams<{ corpid: string }>();
  return (
    <Square inset="lg">
      <PageHeader>
        <Stack y="xxx-sm">
          <Heading variant="h1">Invoice Recipients</Heading>
        </Stack>
        <Breadcrumbs
          breadcrumbs={[
            {
              label: 'Admin home',
              ...getHomeBreadcrumb(corpid),
            },
          ]}
        />
      </PageHeader>
      <Stack y="md">
        <PageSection>
          <EnterpriseManageInvoiceRecipients
            subtotalMethod={SubtotalInvoiceMethod.MEAL_TYPE}
            corpId={corpid as string}
          />
        </PageSection>
      </Stack>
    </Square>
  );
}
